import React from "react";
import "./finalContact.scss";

const FinalContact = () => {
  return (
    <div className="contact-page">
      {/* Banner Section */}
      <div style={{backgroundImage:"url(/contact.jpg",objectFit:'fill'}} className="banner">
        <h1>Contact Us</h1>
      </div>

      {/* Image and Form Section */}
      <div className="content-section">
        <div className="content-image">
          <img 
            src="/customer-support.svg" 
            alt="Contact Illustration" 
          />
        </div>
        <div className="content-form">
          <h2>Get in Touch</h2>
          <p>We'd love to hear from you! Fill out the form below to get in touch.</p>
          <form className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" placeholder="Your Name" />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" placeholder="Your Email" />
            </div>
            <div className="form-group">
              <label htmlFor="number">Email</label>
              <input type="number" id="number" placeholder="Your Mobile number" />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" rows="5" placeholder="Your Message"></textarea>
            </div>
            <button type="submit" className="submit-button">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FinalContact;
